import { Router, ReactLocation, Route, Outlet } from "@tanstack/react-location";
import { LoginScreen, SignupScreen, ForgotPasswordScreen } from '../screens';

const routes: Route[] = [
    { path: "/", element: <LoginScreen /> },
    { path: "/login", element: <LoginScreen /> },
    { path: "/signup", element: <SignupScreen /> },
    { path: "/forgotPassword", element: <ForgotPasswordScreen /> }
];

const location = new ReactLocation();
function AuthNavigation(props: any) {
    return (
        <Router location={location} routes={routes}>
            <Outlet />
        </Router>
    );
}

export default AuthNavigation;